import { chiefsOrderLevel } from "./chiefsOrderLevel.model";
import { review } from "./chiefsorderdetailsmodel.model";
import { IUploadFile } from "../../common/services/document-management.service";
import { Note } from "../../common/models/note.model";
import { Signature } from "../../common/models/signature.model";
import { OnBaseKeywordValue } from "../../common/models/onBaseIntegrationAndMapping.model";
import { Group } from "../../admin/models/group.model";
import { IReportContextValue } from "./mergefieldsmodel.model";

export class coReviewViewModel {
    priorLevel?: chiefsOrderLevel;
    currentLevel?: chiefsOrderLevel;
    nextLevelOfReviewRequiresGroupSelection?: boolean;
    userSelectedGroup?: Group;
    instanceId?: string;
	signed?: boolean;
    templateId?: string;
    templateName?: string;
    returnToGp?: string;
    returnToGpId?: string;
    files?: IUploadFile[];
    postIssueFiles?: IUploadFile[];
    onBaseKeywords?: OnBaseKeywordValue[];
    reviews: review[];
    signature?: Signature;
    timeline: any[];
    notes: Note[];
    organizationName?: string;
    chiefsOrderNumber?: string;
    mergeFields?: IReportContextValue[];


    get currentReview(): review {
        if (this.reviews.length === 0) return null;
        return this.reviews[this.reviews.length - 1];
    }

    constructor() {
        this.reviews = [];
        this.files = [];
        this.postIssueFiles = [];
        this.notes = [];
        this.timeline = [];
        this.mergeFields = [];
    }
}

export interface returnArray {
    id: string;
    name: string;
}
